import { getMessage } from '@shared/utils';
import type { TextFieldProps } from '@mui/material/TextField';
import React from 'react';
import type { UseFormRegister } from 'react-hook-form';

import { FormField, type FormFieldProps } from './FormField';

interface CustomTextInputProps extends Omit<TextFieldProps, 'inputProps'> {
  name: string;
  lbl?: string;
  ph?: string;
  dv?: string;
  m?: boolean;
  rgx?: string;
  ml?: number;
  mxl?: number;
  mxv?: number;
  mv?: number;
  d?: boolean;
  register: UseFormRegister<any>;
  errMs?: string;
  style?: React.CSSProperties;
  className?: string;
  propsTextField?: Partial<Omit<FormFieldProps, 'label'>>;
}

const CustomTextInput: React.FC<CustomTextInputProps> = ({
  name,
  lbl = '',
  ph = '',
  dv = '',
  m = false,
  rgx = '',
  ml,
  mxl,
  mxv,
  mv,
  d = false,
  register,
  errMs = '',
  style,
  className,
  propsTextField = {},
}) => {
  const regex = decodeURIComponent(rgx ?? '');
  const validators: Record<string, any> = {
    required: m ? { value: m, message: getMessage('requiredField') } : undefined,
    validate: rgx
      ? {
          positive: (v: string) => new RegExp(regex).test(v) || getMessage('INPUT_REGEX'),
        }
      : undefined,
    max: mxv ? { value: mxv, message: getMessage('INPUT_MAX_VALUE')?.replace('$1', String(mxv)) } : undefined,
    min: mv ? { value: mv, message: getMessage('INPUT_MIN_VALUE')?.replace('$1', String(mv)) } : undefined,
    maxLength: mxl ? { value: mxl, message: getMessage('INPUT_MAX_LENGTH')?.replace('$1', String(mxl)) } : undefined,
    minLength: ml ? { value: ml, message: getMessage('INPUT_MIN_LENGTH')?.replace('$1', String(ml)) } : undefined,
  };

  Object.keys(validators).forEach((key) => {
    if (!validators[key]) delete validators[key];
  });

  const { ref, ...registration } = register(name, validators);

  return (
    <FormField
      label={lbl}
      required={m}
      placeholder={ph}
      defaultValue={dv}
      disabled={d}
      maxLength={mxl}
      {...registration}
      slotProps={{
        htmlInput: {
          ref,
          type: mv || mxv ? 'number' : 'text',
          step: mv || mxv ? 'any' : undefined,
        },
      }}
      style={style}
      className={className}
      error={errMs}
      {...propsTextField}
    />
  );
};

export const buildInputText = (
  jsonField: Omit<CustomTextInputProps, 'register' | 'errMs'>,
  register: CustomTextInputProps['register'],
  error?: string,
  className?: string,
  style?: React.CSSProperties
) => {
  return <CustomTextInput {...jsonField} register={register} className={className} style={style} errMs={error} />;
};

export default CustomTextInput;
